import AnimatedLink from '@stone/components/routerTransitions/AnimatedLink';
import analytics from '@stone/utils/analytics';
import React, { useContext } from 'react';
import { __RouterContext } from 'react-router';
import useregisterProducts from '../routerTransitions/useRegisterProducts';
const ProductLink = (props) => {
    const router = !props.ignoreRouting && (navigator.userAgent || '').indexOf('bot') === -1 && useContext(__RouterContext);
    const linkProps = {
        productId: props.product.id,
        to: props.product.route,
        className: props.className,
        from: {
            state: {
                thumbStartIndex: props.index,
            },
        },
    };
    if (props.tileRef && props.originalUuid) {
        useregisterProducts(props.originalUuid, props.tileRef);
    }
    const onClickAction = (event) => {
        var _a;
        if (props.noClickTracking) {
            return;
        }
        else if ((_a = props === null || props === void 0 ? void 0 : props.analyticsData) === null || _a === void 0 ? void 0 : _a.item_list_name) {
            analytics.productClick({
                product: props.product,
                index: props.product.analyticsIndex,
                item_list_name: props.analyticsData.item_list_name,
            });
        }
    };
    return router ? (React.createElement(AnimatedLink, Object.assign({ product: props.product }, linkProps, { trackingAction: onClickAction, ariaLabel: props.ariaLabel, ariaHidden: props.ariaHidden, tabIndex: props.tabIndex, originalUuid: props.originalUuid }), props.children)) : (React.createElement("a", { id: props.id, href: props.product.productUrl, onClick: onClickAction, className: props.className, "aria-label": props.ariaLabel, "aria-hidden": props.ariaHidden, tabIndex: props.tabIndex, "aria-labelledby": props.ariaLabelledby, onFocus: props.onFocus, onBlur: props.onBlur, onMouseEnter: props.onMouseEnter, onMouseLeave: props.onMouseLeave }, props.children));
};
export default ProductLink;
